const customerCareEmail = 'customercare@italist.com';
const pressEmail = 'press@italist.com';
const businessEmail = 'business@italist.com';
const hrEmail = 'hr@italist.com';
const marketingEmail = 'marketing@italist.com';
const legalEmail = 'legal@italist.com';

const mailTo = email => `mailto:${encodeURIComponent(email)}`;

export { customerCareEmail, pressEmail, businessEmail, hrEmail, legalEmail, marketingEmail, mailTo };
